/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCreditFeeBreakdownDTO interface.
 */
export function instanceOfWarehouseCreditFeeBreakdownDTO(value) {
    return true;
}
export function WarehouseCreditFeeBreakdownDTOFromJSON(json) {
    return WarehouseCreditFeeBreakdownDTOFromJSONTyped(json, false);
}
export function WarehouseCreditFeeBreakdownDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'carrierPrice': json['carrierPrice'] == null ? undefined : json['carrierPrice'],
        'discountAmount': json['discountAmount'] == null ? undefined : json['discountAmount'],
        'insuranceFee': json['insuranceFee'] == null ? undefined : json['insuranceFee'],
        'serviceFees': json['serviceFees'] == null ? undefined : json['serviceFees'],
        'customsFees': json['customsFees'] == null ? undefined : json['customsFees'],
        'otherFees': json['otherFees'] == null ? undefined : json['otherFees'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'addedLaterAmount': json['addedLaterAmount'] == null ? undefined : json['addedLaterAmount'],
    };
}
export function WarehouseCreditFeeBreakdownDTOToJSON(json) {
    return WarehouseCreditFeeBreakdownDTOToJSONTyped(json, false);
}
export function WarehouseCreditFeeBreakdownDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'carrierPrice': value['carrierPrice'],
        'discountAmount': value['discountAmount'],
        'insuranceFee': value['insuranceFee'],
        'serviceFees': value['serviceFees'],
        'customsFees': value['customsFees'],
        'otherFees': value['otherFees'],
        'totalPrice': value['totalPrice'],
        'addedLaterAmount': value['addedLaterAmount'],
    };
}
